import { useState } from "react";
import type { FaqItem } from "@/mocks/faqs";

export default function FaqAccordion({ items, defaultOpenId }: { items: FaqItem[]; defaultOpenId?: string }) {
  const [openId, setOpenId] = useState<string | null>(defaultOpenId ?? null);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item) => {
        const open = openId === item.id;
        return (
          <div key={item.id}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenId(open ? null : item.id)}
                aria-expanded={open}
                className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-6"
              >
                <span className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-accent-100 font-label text-xs font-bold text-accent-800">
                    Q
                  </span>
                  <span className="font-heading text-base font-semibold leading-relaxed text-foreground-950">
                    {item.question}
                  </span>
                </span>
                <i
                  className={open ? "ri-subtract-line text-xl text-primary-600" : "ri-add-line text-xl text-foreground-500"}
                  aria-hidden="true"
                ></i>
              </button>
            </h3>
            {open && (
              <div className="px-5 pb-6 md:px-6">
                <div className="ml-9 border-l-2 border-primary-200 pl-4">
                  <p className="text-sm leading-loose text-foreground-700">{item.answer}</p>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}